import { render, staticRenderFns } from "./IncomingCallsAlert.vue?vue&type=template&id=ae40cd24&scoped=true"
import script from "./IncomingCallsAlert.vue?vue&type=script&lang=js"
export * from "./IncomingCallsAlert.vue?vue&type=script&lang=js"
import style0 from "./IncomingCallsAlert.vue?vue&type=style&index=0&id=ae40cd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae40cd24",
  null
  
)

export default component.exports